/**
 * Styles for the Multi-select Stacked Component.
 */
import { ViewProps } from 'react-native';

import {
  flexbox,
  FlexboxProps,
  space,
  SpaceProps,
  layout,
  LayoutProps,
  borderRadius,
  BorderRadiusProps,
} from 'styled-system';
import styledNative from 'styled-components/native';
import styled from 'styled-components';
import { Colors } from 'theme/colors';
import { FontSize } from 'theme/fonts';
import { Regular } from 'theme/text';

export const Container = styledNative.View<ViewProps>`
  background-color: ${Colors.white};
  right: 0;
  left: 0;
  bottom: 0;
  align-items: center;
  width: 100%;
`;

export const CheckListContainer = styledNative.View<FlexboxProps>`
  padding-right: 20px;
  padding-left: 20px;
  align-items: center;
  width: 100%;
  ${flexbox}
`;

export const CheckBoxContainer = styled.div<SpaceProps & LayoutProps & BorderRadiusProps>`
  border-radius: 40px;
  color: green;
  border-radius: 40px;
  ${space}
  ${layout}
  ${borderRadius}
`;

export const CheckBoxInnerContainer = styled.div<SpaceProps & LayoutProps>`
  align-items: center;
  justify-content: center;
  padding-right: 15px;
  padding-left: 25px;
  padding-top: 9px;
  padding-bottom: 9px;
  flex-direction: row;
  min-height: 48px;
  height: 100%;
  display: flex;
  ${space}
  ${layout}
`;

export const BlockContainer = styled.div<LayoutProps>`
  ${layout}
`;

export const BlockIconContainer = styledNative.View<LayoutProps & SpaceProps>`
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  ${layout}
  ${space}
`;

export const BlockCheckboxContainer = styledNative.View`
  width: 100%;
  display: flex;
  align-items: center;
  margin-top: -15px;
  height: 30px;
`;

export const BlockLabelContainer = styledNative.View`
  display: flex;
  align-items: center;
  margin-left: -30px;
  margin-right: -30px;
  margin-top: 24px;
`;

export const CheckBox = styledNative.View`
  border-width: 1px;
  border-radius: 50px;
  border-color: ${({ borderColor }: ViewPropsTypes) => borderColor};
  background-color: ${({ backgroundColor }: ViewPropsTypes) => backgroundColor};
  height: 22px;
  width: 22px;
  justify-content: center;
  align-items: center;
`;

export const DesktopCheckBox = styledNative(CheckBox)`
  height: 30px;
  width: 30px;
`;

export const OptionText = styledNative(Regular)`
  color: ${Colors.black};
  font-size: ${FontSize.H6};
  line-height: ${FontSize.H6};
  padding-left: 15px;
  padding-right: 22px;
`;

export const BlockOptionText = styledNative(Regular)`
  color: ${Colors.black};
  font-size: ${FontSize.H6};
  text-align: center;
  max-width: 184px;
`;

export const Spacer = styledNative.View`
  flex: 1;
`;

/** Type definitions */
interface ViewPropsTypes extends ViewProps {
  /** Indicates if an option has been selected. */
  isChecked?: boolean;
  /** background color */
  backgroundColor: string;
  /** border color */
  borderColor: string;
}
